module.exports = __webpack_public_path__ + "static/media/Michelle F.23b574d1.png";